/* eslint-disable import/no-extraneous-dependencies */
import { extendTheme, theme } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";
import { generateColorPalette } from "../utils";
const internalTheme = {
    config: {
        initialColorMode: "system",
        useSystemColorMode: true,
    },
    styles: {
        global: (props) => ({
            body: {
                fontFamily: "body",
                color: mode("gray.800", "whiteAlpha.900")(props),
                bg: mode("white", "gray.800")(props),
                transitionProperty: "background-color",
                transitionDuration: "normal",
                lineHeight: "base",
            },
            "*::placeholder": {
                color: mode("gray.400", "whiteAlpha.400")(props),
            },
            "*, *::before, &::after": {
                borderColor: mode("gray.200", "whiteAlpha.300")(props),
                wordWrap: "break-word",
            },
        }),
    },
    colors: {
        primary: {
            50: "#ffecef",
            100: "#ffd0d4",
            200: "#f3a09d",
            300: "#ea7b77",
            400: "#f55e54",
            500: "#fb513b",
            600: "#ec473a",
            700: "#da3e34",
            800: "#cc372d",
            900: "#bd2d21",
        },
        secondary: {
            50: "#e7ebf8",
            100: "#c3ccee",
            200: "#9babe2",
            300: "#718ad6",
            400: "#4f70ce",
            500: "#2457c5",
            600: "#1c4fbb",
            700: "#0b45af",
            800: "#003ba3",
            900: "#00288f",
        },
        info: {
            50: "#def5f6",
            100: "#aee5e9",
            200: "#7bd4dc",
            300: "#47c2ce",
            400: "#22b6c4",
            500: "#00a9bb",
            600: "#009aaa",
            700: "#038691",
            800: "#05727a",
            900: "#085051",
        },
        success: {
            50: "#f2f7e7",
            100: "#deecc3",
            200: "#c8df9c",
            300: "#b2d273",
            400: "#a1c953",
            500: "#90bf31",
            600: "#81b02a",
            700: "#81b02a",
            800: "#578816",
            900: "#326700",
        },
        warning: {
            50: "#FFFAF0",
            100: "#FEEBC8",
            200: "#FBD38D",
            300: "#F6AD55",
            400: "#ED8936",
            500: "#DD6B20",
            600: "#C05621",
            700: "#9C4221",
            800: "#7B341E",
            900: "#652B19",
        },
        error: {
            50: "#FFF5F5",
            100: "#FED7D7",
            200: "#FEB2B2",
            300: "#FC8181",
            400: "#F56565",
            500: "#E53E3E",
            600: "#C53030",
            700: "#9B2C2C",
            800: "#822727",
            900: "#63171B",
        },
        // Generated using https://materialpalettes.com/
        gray: {
            50: "#fafafa",
            100: "#f4f4f4",
            200: "#ededed",
            300: "#dedede",
            400: "#bbbbbb",
            500: "#9c9c9c",
            600: "#737373",
            700: "#5f5f5f",
            800: "#404040",
            900: "#1f1f1f",
        },
        gold: {
            50: "#fef9eb",
            100: "#fceecc",
            200: "#f9e4ad",
            300: "#f5da92",
            400: "#f1d280",
            500: "#edcb70",
            600: "#dcbb6a",
            700: "#c5a663",
            800: "#ad915e",
            900: "#837057",
        },
    },
    components: {
        NoomLoader: {
            baseStyle: {
                layer1: generateColorPalette("#EB7000"),
                layer2: generateColorPalette("#FFB81D"),
                layer3: generateColorPalette("#FFCF04"),
            },
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        CompassLoader: {
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        ClientLoader: {
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        Popover: {
            variants: {
                responsive: {
                    popper: {
                        maxWidth: "unset",
                        width: "unset",
                    },
                },
            },
        },
        Heading: {
            baseStyle: {
                fontWeight: 300,
            },
        },
    },
};
export function extendInternalTheme(themeOverride) {
    return extendTheme(theme, internalTheme, themeOverride);
}
export default extendTheme(theme, internalTheme);
//# sourceMappingURL=index.js.map